const items = [
  "Entendi o que é ser amado por alguém que desperta minha melhor versão",
  "Aprendi que o silêncio ao seu lado é confortável, não vazio...",
  "Que nossas diferenças não nos separam, elas nos completam",
  "Percebi que amo cuidar de você, assim como você cuida de mim",
  "E percebi, acima de tudo, que te amar fica mais fácil e mais profundo a cada dia",
];

function Changes() {
  return (
    <div
      id="changes"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container py-5">
        <h1>Nesse último ano</h1>
        <br />
        {items.map((item, i) => (
          <div key={i}>
            <h3>{item}</h3>
            <br />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Changes;
